export default "__VITE_ASSET__079388ae__"